import React, { Component } from 'react'

import Scrollable from 'components/Utils/Scrollable'
import enhance from './enhance'
import NoteItem from './Items/Note'
import Loader from './Items/Loader'
import { LIST_ITEM_NOTE, LIST_ITEM_LOADER } from './constants'

class StructuredList extends Component {
  state = {
    loadOffsetStart: 0,
    loadOffsetEnd: 0,
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state.loadOffsetStart !== nextState.loadOffsetStart ||
      this.state.loadOffsetEnd !== nextState.loadOffsetEnd ||
      this.props.items !== nextProps.items
    )
  }

  // Render all items with their absolute offset for lazy loading
  renderItems() {
    let offset = 0
    return this.props.items.map(item => {
      const comp = this.renderItem(item, offset)
      offset += item.height
      return comp
    })
  }

  renderItem = (item, offset = 0) => {
    const rowProps = {
      key: item.key,
      item,
      ...item.data,
    }

    switch (item.type) {
      case LIST_ITEM_NOTE:
        return <NoteItem {...rowProps} />
      case LIST_ITEM_LOADER:
        const isVisible =
          this.state.loadOffsetStart <= offset &&
          offset <= this.state.loadOffsetEnd
        const loaderProps = {
          isVisible,
          items: this.props.items,
        }
        return <Loader {...loaderProps} {...rowProps} />
      default:
        return false
    }
  }

  onScroll = event => {
    const el = event.target
    this.computeLoadOffset(el)
  }

  // Compute visible rectangle to know which list to load
  computeLoadOffset = el => {
    const { scrollTop, offsetHeight } = el
    const loadOffsetPadding = 50
    const loadOffsetStart = scrollTop - loadOffsetPadding
    const loadOffsetEnd = scrollTop + offsetHeight + loadOffsetPadding
    this.setState({
      loadOffsetStart,
      loadOffsetEnd,
    })
  }

  render() {
    return (
      <Scrollable
        key="list"
        className="position-relative width-full border-shade-50"
        onScroll={this.onScroll}
        scrollingClassName={'border-top-medium'}
      >
        {this.renderItems()}
      </Scrollable>
    )
  }
}

export default enhance(StructuredList)
